import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('COLLIDING_EVENTS');
